// extracted by mini-css-extract-plugin
export var main = "backbutton-module--main--cbe55";
export var middleLine = "backbutton-module--middleLine--d8e30";